import { Skeleton, Table, Text } from "@chakra-ui/react";
import React from "react";

const AllTransactionsSkeleton = () => {
  return (
    <Table.ScrollArea
      borderWidth="1px"
      rounded="md"
      maxHeight="70vh"
      width="100%"
    >
      <Table.Root interactive variant="outline" stickyHeader>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="10%">Sr.No.</Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Amount
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Card Info
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Status
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Type
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Transaction ID
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Created At
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Actions
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Array.from({ length: 10 })?.map((_, index) => (
            <Table.Row key={index}>
              <Table.Cell padding="1rem">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>

              <Table.Cell textAlign="center" fontSize="xs">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};

export default AllTransactionsSkeleton;
